module.exports = __webpack_public_path__ + "img/20211008.3ae2c791.gif";